// When we move to new dependency system, we can get the router from imports
// For now just re-export the inner interactor for consumers to call into manually
import router from '@updater-core/interactors/shell/router';
import { createLogger } from '@updater-core/lib/logger';
import { v4 as uuidv4 } from 'uuid';
import createRouterPersistanceInteractor from './interactor';

const routerPersistance = createRouterPersistanceInteractor({
  router,
});
export default routerPersistance;

const fallbackLogger = createLogger(
  true,
  '[ROUTER_PERSISTANCE]',
  'color: #f3ab38'
);

export function createPersistedInteractor({
  log = fallbackLogger.log,
  persistenceKey = uuidv4(),
  createInteractor,
  dependencies,
  onCreated,
  basePathRegExp,
}: {
  log?: Function;
  persistenceKey?: string;
  createInteractor: Function;
  dependencies: any;
  onCreated?: Function;
  basePathRegExp: string | RegExp;
}) {
  let interactor = routerPersistance.selectors.get(persistenceKey);

  if (!interactor) {
    log('interactor not found, creating');

    interactor = createInteractor(dependencies);

    onCreated?.(interactor);

    routerPersistance.actions.add(
      persistenceKey,
      new RegExp(basePathRegExp),
      interactor,
      interactor.destroy
    );
  } else {
    log('interactor already exists, using');
  }

  return {
    ...interactor,
    destroy: () => {
      log('destroy called externally but supressed');
    },
  };
}
